// 🧪 MXS — JS media-query helpers
// Espejo runtime de los mixins PostCSS para hooks dinámicos.

const desktop = 1440
const resp    = 1194
const mobile  = 375
const PTMax   = 540

export const MDQ = {
  isMain:    `(min-width: ${resp}px), (min-width: ${PTMax}px) and (orientation: landscape)`,
  isPT:      `(max-width: ${resp}px) and (orientation: portrait)`,
  isPc:      `(min-width: ${resp}px)`,
  isToch:    `(min-width: ${desktop}px)`,
  isMobile:  `(max-width: ${PTMax}px)`,
  hover:     `(hover: hover) and (pointer: fine)`,
  touch:     `(hover: none) and (pointer: coarse)`,
  reduced:   `(prefers-reduced-motion: reduce)`,
}

// Devuelve booleano actual para una media query
export const match = (key) => window.matchMedia(MDQ[key]).matches

// Subscribe a cambios; devuelve unsubscribe
export const listen = (key, cb) => {
  const mql = window.matchMedia(MDQ[key])
  const handler = (e) => cb(e.matches)
  mql.addEventListener('change', handler)
  return () => mql.removeEventListener('change', handler)
}
